import React, { useState } from "react";
import nimolipng from "./Project-Resources/nimoli.png";
import mespng from "./Project-Resources/mes.png";
import ecommerce from "./Project-Resources/e-commerce.png";
import globalfortify from "./Project-Resources/globalfortify.png";
import famtree from "./Project-Resources/famtree.png";
import biztv from "./Project-Resources/biztv.png";
import alx from "./Project-Resources/alx.png";
import { FaGlobe, FaGithub } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./projects.css";
import { BlurhashCanvas } from "react-blurhash";

const projectList = [
  {
    image: nimolipng,
    url: "https://nimolimedical.co.ke",
    giturl: "https://github.com/mmmyykkeee/nimoli",
    title: "Nimoli Medical Services",
    isLoaded: false,
    blurHash: "LDFY$3Ri_3M{~qt4M|bF_4n#Rlxb",
  },
  {
    image: mespng,
    url: "https://m-e-s.co.ke",
    giturl: "https://github.com/mmmyykkeee/Wanguku",
    title: "Modern Enginering Solutions",
    isLoaded: false,
    blurHash: "LWMab7?5RkNK?bRnWCoc~VNgobs+",
  },
  {
    image: ecommerce,
    url: "https://e-commerce-agriculture.vercel.app/",
    giturl: "https://github.com/mmmyykkeee/e-commerce",
    title: "E-Commerce",
    isLoaded: false,
    blurHash: "LdR{fAtS.TR4Mwbbo#WB%$RPMctS",
  },
  {
    image: globalfortify,
    url: "https://global-fortify.netlify.app/",
    giturl: "https://github.com/mmmyykkeee/global-fortify-kenya-",
    title: "Global Fortify Kenya",
    isLoaded: false,
    blurHash: "L2AxGd%01sIt3BeU?^IW01oh~CRO",
  },
  {
    image: famtree,
    url: "/",
    giturl: "https://github.com/mugonyakirima/mugo-nyakirima-Family-tree",
    title: "Family Tree",
    isLoaded: false,
    blurHash: "L13[k|R*00t7IAfk%gWB0Lof^*WV",
  },
  {
    image: biztv,
    url: "/",
    giturl: "https://github.com/biztv/Sports",
    title: "Sports",
    isLoaded: false,
    blurHash: "L4SPhKSj-A9Z}=xZJAM{5Sx^$*IU",
  },
  {
    image: alx,
    url: "/",
    giturl: "https://github.com/mmmyykkeee/alx-low_level_programming",
    title: "ALX Low Level Programming",
    isLoaded: false,
    blurHash: "L4SPhKSj-A9Z}=xZJAM{5Sx^$*IU",
  },
];

function Projects() {
  const [projectListState, setProjectListState] = useState(projectList);

  const handleImageLoad = (index) => {
    const updatedProjectList = [...projectListState];
    updatedProjectList[index].isLoaded = true;
    setProjectListState(updatedProjectList);
  };

  return (
    <div className="root-containersss ">
      <div className="container projects-container">
        <h2 className="text-center pt-4">Projects</h2>
        <p className="text-center">Check out my Projects</p>
        <div className="row d-flex justify-content-around mx-auto ">
          {projectListState.map((project, index) => (
            <div
              key={project.title}
              className="col-lg-5 col-md-5 card mb-3 rounded project position-relative d-flex"
            >
              <div className="position-absolute text-white card__info text-center bg-dark rounded mx-5 w-75 mt-2">
                <h5>{project.title}</h5>
                <div className="d-flex icons rounded position-absolute">
                  <div className="d-flex mx-1 mt-3 git">
                    <Link to={project.giturl} target="_blank">
                      <FaGithub />
                    </Link>
                  </div>
                  <div className="d-flex mx-1  mt-3 globe">
                    <Link to={project.url} target="_blank">
                      <FaGlobe />
                    </Link>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: !project.isLoaded ? "inline" : "none",
                }}
              >
                <BlurhashCanvas
                  width="600"
                  height="200"
                  hash={project.blurHash}
                />
              </div>
              <img
                src={project.image}
                className="img-fluid"
                alt={project.title}
                onLoad={() => {
                  handleImageLoad(index);
                }}
                style={{
                  display: project.isLoaded ? "inline" : "none",
                  height: "400",
                  width: "200",
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Projects;
